import { render } from "./PersonalSelect.vue?vue&type=template&id=1178995e"
import script from "./PersonalSelect.vue?vue&type=script&lang=js"
export * from "./PersonalSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__